import { Box, Flex, useDisclosure } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { FormattedMessage } from "react-intl";

import { RanaModal } from "@nens/ranalib";

import { AnyUser } from "../types/any-user";
import { useProfile } from "../use-profile";

import { ProfileImageEdit } from "./profile-image-edit";
import { ProfileModalForm } from "./profile-modal-form";

export function ProfileModal({ user, children }: PropsWithChildren<{ user: AnyUser }>) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isApiKeyUser } = useProfile(user);
  if (!user) return;

  return (
    <>
      <Box
        onClick={(event) => {
          onOpen();
          event.stopPropagation();
        }}
        cursor="pointer"
      >
        <Box>{children}</Box>
      </Box>
      <RanaModal
        isOpen={isOpen}
        onClose={onClose}
        topBar={
          isApiKeyUser ? (
            <FormattedMessage
              defaultMessage="API Key User profile"
              id="profile.api_key_user_profile"
            />
          ) : (
            <FormattedMessage defaultMessage="User profile" id="profile.user_profile" />
          )
        }
      >
        <Flex w="full" pt={2} pb={6} justifyContent="center">
          <ProfileImageEdit user={user} />
        </Flex>
        <ProfileModalForm user={user} />
      </RanaModal>
    </>
  );
}
